import { render, staticRenderFns } from "./PostPhoto.vue?vue&type=template&id=02cbe06c&"
import script from "./PostPhoto.vue?vue&type=script&lang=js&"
export * from "./PostPhoto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports